import { FamiliaDoProdutoServiceAdapter } from "@/usecases/produto/tipoProduto"
import { injectable } from "inversify-props"
import { criarFamiliaDoProduto, editarFamiliaDoProduto, listarFamiliasDoProduto } from "@/api/produtos"
import { AxiosRequestConfig } from "axios"
import { FamiliaDoProduto } from "@/models"

@injectable()
export class FamiliaDoProdutoService implements FamiliaDoProdutoServiceAdapter {
	listarFamiliasDoProduto = async (params?: any, config?: AxiosRequestConfig) => await listarFamiliasDoProduto(params, config)
	criarFamiliaDoProduto = async (familiaDoProduto: FamiliaDoProduto) => await criarFamiliaDoProduto(familiaDoProduto)
	editarFamiliaDoProduto = async (familiaDoProduto: FamiliaDoProduto) => await editarFamiliaDoProduto(familiaDoProduto)
}